import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addStartAnimationToSprite } from '../AnimationManager';
import FontKeys from '../FontKeys';
import gameData, { GAME_IMAGES_KEY, SPARKLE_ANIMATION_KEY } from '../gameData';
import HitParticle from '../ninjas/HitParticles/HitParticle';
import TossItemHalf from '../ninjas/TossItemHalf';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';
import ABCyaLib from '@abcya/abcya_lib';

export default class IntroScreenBase extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreenBase.KEY });
  }

  init() {
    this.lblInstructions = null;
    this.swipe = null;
    this.objectDisplay = null;
    this.pointerHand = null;
    this.wrapper = null;

    /** @type {TossItemHalf[]} */
    this.halves = null;

    /** @type {HitParticle[]} */
    this.hitParticles = null;

    this.displayNum = null;
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0, 'MainBackground', this, GAME_IMAGES_KEY).setOrigin(0);

    this.lblInstructions = ABCyaPhaser.Text.addText(this.scale.width / 2,100,'62pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, '', this, true).setOrigin(0.5);

    this.swipe = this.add.sprite(100, 200, ABCyaPhaser.Images.DEFAULT_ATLAS, 0).setVisible(false);
    addStartAnimationToSprite(this.swipe, false);

    this.createDisplayNum();

    this.pointerHand = ABCyaPhaser.Images.addImage(this.swipe.x, this.swipe.y, UIAssetKeys._HandPointer, this).setOrigin(0)
      .setAlpha(0);

    this.time.delayedCall(ABCyaLib.Environment.instance.gameConfig.introScreenExtraPause ? 2000 : 1000, this.doSlice, null, this);
  }

  createDisplayNum() {
    this.objectDisplay = ABCyaPhaser.Images.addImage(this.scale.width / 2,this.swipe.y + this.swipe.height / 2 + 26, `Num${this.displayNum}`, this, GAME_IMAGES_KEY);
    this.objectDisplay.angle = 30;
  }

  doSlice () {
    ABCyaPhaser.Tweens.addTween(this.pointerHand, 600, { x: this.swipe.x + this.swipe.width, y: this.swipe.y + this.swipe.height, alpha: 1 }, Phaser.Math.Easing.Linear, () => this.goAway());
    this.swipe.play('start');
    this.swipe.setVisible(true);

    this.time.delayedCall(200, this.sliceIntroObject, null, this);
  }

  goAway (extraItems = []) {
    ABCyaPhaser.Tweens.addTween([this.lblInstructions, this.pointerHand, this.swipe, ...extraItems], 600, { delay: ABCyaLib.Environment.instance.gameConfig.introScreenExtraPause ? 1500 : 500, alpha: 0 }, Phaser.Math.Easing.Linear, () => this.allDone());
  }

  allDone () {
    this.scene.start(Game.KEY);
  }

  sliceIntroObject () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._correct_slice, this);

    this.halves = [];
    this.hitParticles = [];

    const pt = ABCyaPhaser.GameObjects.getScreenPosition(this.objectDisplay);
    let item = new TossItemHalf(this);
    item.reset(`Num${this.displayNum}`, 1, pt.x,pt.y);
    item.angle = this.objectDisplay.angle;
    this.halves.push(item);
    this.add.existing(item);

    item = new TossItemHalf(this);
    item.reset(`Num${this.displayNum}`, 2, pt.x,pt.y);
    item.angle = this.objectDisplay.angle;
    this.halves.push(item);
    this.add.existing(item);

    const count = 50;
    for (let i = 0; i < count; i++) {
      item = new HitParticle(this);
      item.reset(pt.x,pt.y,Phaser.Math.Between(0,this.textures.get(SPARKLE_ANIMATION_KEY).frameTotal - 2));
      this.add.existing(item);
      this.hitParticles.push(item);
    }

    this.objectDisplay.destroy();
  }

  update(time, delta) {
    if (this.halves) {
      const len = this.halves.length - 1;
      for (let i = len; i >= 0; i--) {
        this.halves[i].tick(delta);
      }
    }
    if (this.hitParticles) {
      const len = this.hitParticles.length - 1;
      for (let i = len; i >= 0; i--) {
        this.hitParticles[i].tick();
      }
    }
  }
}